import { type FeatureFlagStatus } from '@gonfalon/openapi/types';
// oxlint-disable-next-line no-restricted-imports -- TODO(zod-4): migrate to 'zod/v4'
import { z } from 'zod';

const flagStatusNameSchema = z.enum(['new', 'inactive', 'active', 'launched']);

export function assertFlagStatusName(name: unknown): asserts name is FeatureFlagStatus['name'] {
  flagStatusNameSchema.parse(name);
}
